var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar',{attrs:{"is-white":true}}),_c('v-content',[(!_vm.isMobile)?_c('Pricing'):_vm._e(),(_vm.isMobile)?_c('PricingMobile'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }